<template>
    <div class="category">
        <div class="category-list">
            <div v-for="(category, key) in categoryList" :key="key" class="category-item" :class="getClass(category)" @click="onCategory(category)">{{ category.cidName }}</div>
        </div>
    </div>    
</template>
<script>

export default {
    name: 'CategoryWidget',
    props: {
        list: Array,
        current: Object
    },
    data() {
        return {
            categoryList: []
        }
    },
    created() {
        this.categoryList = this.list
    },
    methods: {
        getClass(category) {
            return this.current.cid === category.cid ? 'active' : ''
        },
        // 点击菜单项
        onCategory(cate) {
            this.$emit('onCategory', cate)
        }
    }
}
</script>
<style scoped>
.category {
    width: 100%;
    overflow: hidden;
    padding: 0 var(--len10);
    box-sizing: border-box;
    background-color: white;
}
.category-list{
    overflow-x: auto;
    display: flex;
    white-space: nowrap;
    overflow-y: hidden;
    height: var(--len40);
    scrollbar-width: none; /* 隐藏滚动条 */
}
.category-item {
    display: inline-block; /* 使元素横向排列 */
    width: var(--len80); 
    height: var(--len40); /* 设置每个item的高度 */
    line-height: var(--len40);
    margin-right: var(--len20); 
    color: black;
    font-size: 0.875rem;
    font-weight: bold; /** 设置元素之间的间距 */
}
.category-item.active{
    color:var(--primary-color);
    border-bottom: 2px solid var(--primary-color);
}
</style>
